<template>
<b-card-group deck class="card-deck-style">
  <b-card id="ios" header="iOS" header-text-variant="left" header-bg-variant="white" class="text-center" body-class="card-body-style">
    <!-- for loading page -->
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
      <template v-slot:header>
        <h4 class="mb-0">iOS Platform</h4>
      </template>
       <b-row>
         <!--sm="6"
          lg="1"-->
        <b-col
          md="5"
          v-for="app in iosApps(apps)"
          :key="app.id"
          class="col-md5-override"
        >
          <b-card
            :no-body="true"
            class="card-style handcursor"
            @click="viewDetails(app)"
          >
            <b-card-body class="p-3 clearfix">
              <img
                :src="app.thumbnail"
                class="thumbnail"
                @error="altImg"
              >
              <div class="h5 text-info mb-0 mt-2 text-center app-title">{{app.name}}</div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
  </b-card>
  <b-card id="android" header="Android" header-text-variant="left" header-bg-variant="white" class="text-center" body-class="card-body-style">
      <template v-slot:header>
        <h4 class="mb-0">Android Platform</h4>
      </template>
      <b-row>
        <b-col
          md="5"
          v-for="app in androidApps(apps)"
          :key="app.id"
          class="col-md5-override"
        >
          <b-card
            :no-body="true"
            class="card-style handcursor"
            @click="viewDetails(app)"
          >
            <b-card-body class="p-3 clearfix">
              <img
                :src="app.thumbnail"
                class="thumbnail"
                @error="altImg"
              >
              <div class="h5 text-info mb-0 mt-2 text-center app-title">{{app.name}}</div>
            </b-card-body>
          </b-card>
        </b-col>
    </b-row>
  </b-card>
</b-card-group>
</template>

<script>

import { getPreviousVersion } from '@/helpers/appstore.js';
import Loading from '@/components/Loading';

export default {
  data () {
    return {
      apps: [],
      altImage: require('@/assets/notavailable.png'),
      isLoading: false
    };
  },
  methods: {
    viewDetails (app) {
      let selectedApp = app;
      if (selectedApp.noVersion) {
        alert('WARNING: This app is not ready for download since there is no version attached to it. Thank you.');
      }
      sessionStorage.setItem('app', JSON.stringify(selectedApp));
      document.location = this.getUrlToApp(selectedApp.id);
    },
    altImg (e) {
      e.target.src = this.altImage;
    },
    getUrlToApp (id) {
      let path = this.$router.resolve({ name: 'apps-details', params: { id: id } }).href;
      return window.location.origin + path;
    },
    async getAppList () {
      this.isLoading = true;
      sessionStorage.removeItem('app');
      const firstResponse = await this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app?page=1');
      const appStoreData = firstResponse.data.data.appStores;

      for (const appData of appStoreData) {
        const secondResponse = await this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/app/${appData.id}/version`);
        let versions = secondResponse.data.data.versions;
        let currentVersionResults = versions.filter(value => true === value.isCurrent);
        let currentVersion = currentVersionResults[0];
        let currentVersionIndex = versions.findIndex(value => true === value.isCurrent);
        let thumbnail = '';
        let noVersion = true; // Has version/no version indicator
        if (currentVersionResults.length > 0 || versions.length > 0) {
          noVersion = false;
        }
        if (0 === currentVersionResults.length) {
          currentVersion = versions[0];
        }
        let previousVersion = getPreviousVersion(currentVersionIndex, currentVersion, versions);
        thumbnail = previousVersion ? previousVersion.thumbnail : '';

        this.apps.push({
          id: appData.id,
          name: appData.name,
          description: appData.description,
          thumbnail: thumbnail,
          platform: appData.platform,
          noVersion: noVersion
        });
      }
      this.isLoading = false;
    },
    iosApps (apps) {
      return apps.filter(function (app) {
        return 'ios' === app.platform.toLowerCase().trim();
      });
    },
    androidApps (apps) {
      return apps.filter(function (app) {
        return 'android' === app.platform.toLowerCase().trim();
      });
    }
  },
  mounted () {
    document.title = 'Admin Console: App Store';
    this.getAppList();
  },
  components: {
    'app-loading': Loading
  }
};
</script>

<style scoped src="@/assets/css/appstore-home.css"></style>
<style scoped>
.col-md5-override {
  max-width:132px !important;
}
</style>
